"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Roles = void 0;
// @deprecated use IRoles instead
var Roles;
(function (Roles) {
    Roles["DELIVERYMAN"] = "DELIVERYMAN";
})(Roles || (exports.Roles = Roles = {}));
